if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    var is_mobile = true
} else {
    var is_mobile = false
}

var url = window.location.href;
$(document).ready(function () {
// image url from product page
    function product_image_url(arr) {
        var index = arr[0]
        var size = arr[1]
        var img_detail = document.querySelectorAll('.productView-image')[index]
        return img_detail.querySelector('img').src.replace('1024x1024', size)
    }

    if (window.location.href.includes('products')) {
        if ($('#tableOne').length > 0) {
            // if (is_mobile) {
            //     var table_content = document.querySelector('.product-bottom-tabBox #tableOne').outerHTML
            //     // document.querySelector('.mobile-product-table').innerHTML = table_content;
            //     console.log("table_content: ", table_content)
            //     document.querySelectorAll('.table-responsive-stack')[1].classList.add("hide");
            // } else {
            var table = document.querySelector('.product-bottom-tabBox #tableOne')
            var tbody_trs = table.querySelectorAll('tbody tr')
            var td_content = "<td rowspan='" + tbody_trs.length + "'>" + "<img src=" + product_image_url([1, '400x400']) + " alt=''>" +
                "</td>"
            // add th
            document.querySelector('thead tr').innerHTML += "<th> Image </th>"
            // add image to td
            tbody_trs[0].innerHTML += td_content
            // }
        }
    }
})